import moment from 'moment';
import React, { useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IoCalendarClearOutline } from 'react-icons/io5';
import Budget1 from './BudgetSelection/Budget1';
import Budget2 from './BudgetSelection/Budget2';
import Budget4 from './BudgetSelection/Budget4';
import Budget3 from './BudgetSelection/Budget3';

const BudgetSelection = ({ selectedBudget, setSelectedBudget, formData, handleAttributeChange, handleAttributeChange1budget2, handleAttributeChange2budget2, valueOptions, valueOptions1budget2, valueOptions2budget2, attributeOptions, setFormData, additional }) => {
    const [extraBudgetTime, setExtraBudgetTime] = useState(formData?.extraBudgetTime ?? false);
    const [extraBudgetCampaign, setExtraBudgetCampagin] = useState(formData?.extraBudgetCampaign ?? false);
    console.log("FormDate", formData?.extraBudget)
    const handleToggle = () => {
        setExtraBudgetTime(prev => !prev);

        setFormData(prev => ({
            ...prev,
            extraBudgetTime: !extraBudgetTime, // Update extraBudgetTime in formData
        }));
    };
    const handleToggleCampagin = () => {
        setExtraBudgetCampagin(prev => !prev);

        setFormData(prev => ({
            ...prev,
            extraBudgetCampaign: !extraBudgetCampaign, // Update extraBudgetTime in formData
        }));
    };

    const handleDeleteColumn = (index) => {
        setFormData(prev => ({
            ...prev,
            extraBudget: prev.extraBudget.filter((_, i) => i !== index)
        }));
    };

    const handleAddColumn = () => {
        setFormData(prev => ({
            ...prev,
            extraBudget: [...prev.extraBudget, { tillDate: null, count: "", count2: "" }]
        }));
    };

    const handleChange = (index, key, value) => {
        const updatedBudget = [...formData.extraBudget];
        updatedBudget[index][key] = value;
        setFormData(prev => ({
            ...prev,
            extraBudget: updatedBudget
        }));
    };
    return (
        <div className="mt-3">
            <div className="d-flex flex-md-row flex-column gap-md-4 gap-2 pb-md-2 pb-4">
                <p className="text-secondary form-label">Budget Calculation Formula</p>
                <Form.Group controlId="formSelectBudget">
                    <div className="d-flex align-items-center">
                        <Form.Check
                            type="radio"
                            id="budget1"
                            name="budget"
                            label="Budget 1"
                            value="budget"
                            checked={selectedBudget === "budget"}
                            onChange={(e) => setSelectedBudget(e.target.value)}
                            className="me-3"
                        />
                        <Form.Check
                            type="radio"
                            id="budget2"
                            name="budget"
                            label="Budget 2"
                            value="budget2"
                            checked={selectedBudget === "budget2"}
                            onChange={(e) => setSelectedBudget(e.target.value)}
                            className="me-3"
                        />
                        {/* <Form.Check
                            type="radio"
                            id="budget3"
                            name="budget"
                            label="Budget 3"
                            value="budget3"
                            checked={selectedBudget === "budget3"}
                            onChange={(e) => setSelectedBudget(e.target.value)}
                        /> */}
                    </div>
                </Form.Group>
            </div>
            {selectedBudget === "budget" ? (
                <Budget1
                    formData={formData}
                    setFormData={setFormData}
                    handleAttributeChange={handleAttributeChange}
                    attributeOptions={attributeOptions}
                    valueOptions={valueOptions}
                    extraBudgetTime={extraBudgetTime}
                    extraBudgetCampaign={extraBudgetCampaign}
                    handleToggle={handleToggle}
                    handleChange={handleChange}
                    handleAddColumn={handleAddColumn}
                    handleDeleteColumn={handleDeleteColumn}
                    handleToggleCampagin={handleToggleCampagin}
                    additional={additional}
                />
            ) : (
                <Budget2
                    formData={formData}
                    setFormData={setFormData}
                    handleAddColumn={handleAddColumn}
                    attributeOptions={attributeOptions}
                    extraBudgetTime={extraBudgetTime}
                    extraBudgetCampaign={extraBudgetCampaign}
                    handleToggle={handleToggle}
                    handleChange={handleChange}
                    handleDeleteColumn={handleDeleteColumn}
                    handleAttributeChange1budget2={handleAttributeChange1budget2}
                    valueOptions1budget2={valueOptions1budget2}
                    handleAttributeChange2budget2={handleAttributeChange2budget2}
                    valueOptions2budget2={valueOptions2budget2}
                    handleToggleCampagin={handleToggleCampagin}
                    additional={additional}
                />
                // ) : selectedBudget === "budget3" ? (
                //     // formData, setFormData, handleAddColumn, extraBudgetTime, handleToggle, handleChange, handleDeleteColumn
                //     <Budget3
                //         formData={formData}
                //         setFormData={setFormData}
                //         handleAddColumn={handleAddColumn}
                //         extraBudgetTime={extraBudgetTime}
                //         handleToggle={handleToggle}
                //         handleChange={handleChange}
                //         handleDeleteColumn={handleDeleteColumn}
                //     />
                // ) : (
                //     <Budget4
                //         formData={formData}
                //         setFormData={setFormData}
                //         handleAddColumn={handleAddColumn}
                //         attributeOptions={attributeOptions}
                //         extraBudgetTime={extraBudgetTime}
                //         handleToggle={handleToggle}
                //         handleChange={handleChange}
                //         handleDeleteColumn={handleDeleteColumn}
                //     />
            )}
        </div>
    );
}

export default BudgetSelection
